var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.simple)?_c('router-view'):[_c('Header'),_c('Menu'),_c('Main')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }